import React, { Component } from 'react';
import './calculadora.css';
import { Spring } from 'react-spring/renderprops';

export default class Calculadora extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ResistorA_valor: 0,
      ResistorB_valor: 0,
      ResultadoValor: "0 Ω",
    }
    this.calcular = this.calcular.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }
  handleInputChange(event) {
    const value = event.target.value;
    this.setState({
      [event.target.name]: value
    });
  }
  handleChange(event) {
    this.setState({
      ResistorA_valor: event.target.value
    })
  }
  handleKeyPress = (e) => {
    let tecla = e.key;
    if (tecla === 'Enter') {
      this.calcular();
    }
  }
  calcular() {
    let ResiA_valor = this.state.ResistorA_valor ? parseFloat(this.state.ResistorA_valor) : 0;
    let ResiB_valor = this.state.ResistorB_valor ? parseFloat(this.state.ResistorB_valor) : 0;
    let ResiA = ResiA_valor ? ResiA_valor : 0;
    let ResiB = ResiB_valor ? ResiB_valor : 0;
    let ResultadoValor = ResiA + ResiB;
    if (ResultadoValor >= 1000000) {
      ResultadoValor /= 1000000;
      ResultadoValor += " MΩ";
    }
    else if (ResultadoValor >= 1000 && ResultadoValor < 1000000) {
      ResultadoValor /= 1000;
      ResultadoValor += " kΩ";
    } else {
      ResultadoValor.toFixed(2);
      ResultadoValor += " Ω";
    }
    this.setState({ ResultadoValor })
    console.log(this.state);
  }
  // versão velha
  // calcular(ResiA_valor, ResiB_valor){
  //     let ResultadoValor;
  //     if (!ResiA_valor && !ResiB_valor){
  //         return 0 + " Ω";
  //     } else if (!ResiA_valor){
  //         ResultadoValor = ResiB_valor;
  //     } else if (!ResiB_valor){
  //         ResultadoValor = ResiA_valor;
  //     } else {
  //         ResultadoValor = ResiA_valor+ResiB_valor
  //     }
  //     if (ResultadoValor >= 1000000){
  //         ResultadoValor /= 1000000;
  //         ResultadoValor += " MΩ";
  //     }
  //     else if (ResultadoValor >= 1000 && ResultadoValor < 1000000){
  //         ResultadoValor /= 1000;
  //         ResultadoValor += " kΩ";
  //     } else {
  //         ResultadoValor += " Ω";
  //     }
  //     this.setState({ResultadoValor});
  // }

  render() {
    return (
      <Spring
        config={{ tension: 280, friction: 60 }}
        from={{ opacity: 0, marginTop: -500 }}
        to={{ opacity: 1, marginTop: 0 }}
      >
        {props => (
          <div style={props}>
            <div className="calculadora">
              <h1> Associação de Resistores em Série </h1>
              <input type="number" name="ResistorA_valor" value={this.state.value} className="TextBox" onKeyPress={this.handleKeyPress} onChange={this.handleInputChange}></input>
              <input type="number" name="ResistorB_valor" value={this.state.value} className="TextBox" onKeyPress={this.handleKeyPress} onChange={this.handleInputChange}></input>
              <input type="button" className="Botao" value="Calcular" onClick={this.calcular}></input>
              <h2>{this.state.ResultadoValor.toString()}</h2>
            </div>
          </div>
        )}
      </Spring>
    );
  }
}